import React from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SubscriptionDetail } from '@/types/subscriptions/subscription';
// FIXME: そもそもこの階層からimportしたくない。この時点でURL分けるべきでは?
import { Preview as SubscriptionPreview } from '@/components/pages/Subscription/Presentation/Preview';
import { Message } from '@/components/shared/Message';
import { DetailHeader } from './DetailHeader';

import * as styles from './DetailContents.module.scss';

type Props = {
  title: string;
  subscription: SubscriptionDetail;
  cancelSubscription: () => Promise<void>;
};

export const DetailContents: React.FC<Props> = ({
  title,
  subscription,
  cancelSubscription,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledHeader>{title}</StyledHeader>
      <StyledDetailHeaderWrapper>
        <DetailHeader
          subscription={subscription}
          cancelSubscription={cancelSubscription}
        />
      </StyledDetailHeaderWrapper>

      <SubscriptionPreview
        mode="detail"
        isConnecting={false}
        subscription={subscription}
      />
      <Message colorType="normal" className={styles.message}>
        <p className={styles.firstParagraph}>
          {t('text.subscription.disclaimer.first')}
        </p>
        <p>{t('text.subscription.disclaimer.second')}</p>
      </Message>
    </>
  );
};

const StyledHeader = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 30.9px;
`;

const StyledDetailHeaderWrapper = styled.div`
  margin-top: -3.5em;
  margin-bottom: 40px;
`;
